/* Copyright 2021 - 2024 Ellucian Company L.P. and its affiliates.
 * File: IPasswordPolicy.ts */

export interface IPasswordPolicy {
    changePasswordUrl: string
    isLowerCaseRequired: boolean;
    isNumbersRequired: boolean;
    isSpecialCharacterRequired: boolean;
    isUpperCaseRequired: boolean;
    minimumLength: number;
}

export interface IValidatePassword {
    areaName: string;
    password: string;
}

export interface IPasswordPolicyResult {
    passwordValidation: PasswordPolicyErrors;
    passwordMinLength: number;
    userAccountStatus: PasswordPolicyErrors;
    status: number;
    userName: string;
}

export enum PasswordPolicyErrors {
    digits = 0,
    isEmpty = 1,
    lowerCase = 2,
    minLength = 3,
    specialCharacters = 4,
    upperCase = 5,
    newPasswordValid = 6,
    currentPasswordInvalid = 7,
    success = 8,
    UnableToCreateADUser = 14,
    unableToDefineUserName = 15,
    userAlreadyExists = 18
}